import { useParams } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { useFirebase } from "../context/FirebaseContext";

export const useUserData = () => {
  const { auth } = useFirebase();
  const [user] = useAuthState(auth);
  const { userId } = useParams();

  return { userId: userId || user?.uid, user: user };
};
